export enum LeaderboardType {
  /// <summary>
  /// Points that match the predictor points
  /// </summary>
  PredictorPoints = 1,

  /// <summary>
  /// Entries for the predictor not done on points by on correct answers
  /// </summary>
  PredictorEntries = 2,

  /// <summary>
  /// Points that match the trivia points
  /// </summary>
  TriviaPoints = 3,

  /// <summary>
  /// Entries for the trivia not done on points by on correct answers
  /// </summary>
  TriviaEntries = 4,

  /// <summary>
  /// Points that match the fantasy points
  /// </summary>
  FantasyPoints = 5,

  /// <summary>
  /// Points that match the lifetime points of purse 7
  /// </summary>
  LifetimePoints = 6,
}
